"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbSubheading = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const timeout_hook_1 = require("../hooks/timeout.hook");
const Breadcrumb_context_1 = require("./Breadcrumb.context");
const StyledBreadcrumbs = (0, styled_components_1.default)(core_1.Breadcrumbs) `
  color: #a1c1e2 !important;
  & > *,
  li > * {
    font-weight: 500;
  }
  a {
    color: #a1c1e2 !important;
    text-decoration: none;
    transition: color 100ms cubic-bezier(0.075, 0.82, 0.165, 1);
    &:hover {
      color: #fff !important;
    }
  }
  .MuiIconButton-root {
    padding: 0;
  }
`;
// NOTE: taken from https://stackoverflow.com/a/7557433/7013346
function isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
    // rect.width <= 480 &&
    rect.height <= 30 && // new line
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth));
}
const BreadcrumbSubheading = (props) => {
    const { root, defaultData } = props;
    const history = (0, react_router_dom_1.useHistory)();
    const breadcrumbsRef = (0, react_1.useRef)(null);
    const { breadcrumbs } = (0, react_1.useContext)(Breadcrumb_context_1.BreadcrumbContext);
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [shouldCollapse, setShouldCollapse] = (0, react_1.useState)(false);
    const [debounceUpdate, clearDebouncedUpdate] = (0, timeout_hook_1.useTimeout)();
    const items = (0, react_1.useMemo)(() => {
        const all = breadcrumbs.length === 0 && defaultData ? [defaultData] : breadcrumbs;
        return root ? [root, ...all] : all;
    }, [root, breadcrumbs, defaultData]);
    const startIndex = 1;
    const endIndex = items.length - 1;
    // should have more than 2 items to collapse
    const collapsed = shouldCollapse && items.length > 2;
    const first = (0, react_1.useMemo)(() => {
        return collapsed ? items.slice(0, startIndex) : items;
    }, [items, collapsed, startIndex]);
    const between = (0, react_1.useMemo)(() => {
        return collapsed ? items.slice(startIndex, endIndex) : [];
    }, [items, collapsed, startIndex, endIndex]);
    const last = (0, react_1.useMemo)(() => {
        return collapsed ? items.slice(endIndex, items.length) : [];
    }, [items, collapsed, endIndex]);
    const updateCollapse = (0, react_1.useCallback)((ms = 100) => {
        debounceUpdate(() => {
            if (breadcrumbsRef.current) {
                setShouldCollapse(!isElementInViewport(breadcrumbsRef.current));
            }
        }, ms);
    }, [debounceUpdate]);
    (0, react_1.useLayoutEffect)(() => {
        const update = () => updateCollapse();
        window.addEventListener('resize', update);
        update();
        return () => {
            window.removeEventListener('resize', update);
            clearDebouncedUpdate();
        };
    }, [breadcrumbs, clearDebouncedUpdate, updateCollapse]);
    (0, react_1.useLayoutEffect)(() => {
        // check again if not collapsed
        !collapsed && updateCollapse(0);
    }, [collapsed, updateCollapse]);
    const renderBreadcrumb = (breadcrumb) => (react_1.default.createElement(core_1.Typography, { component: react_router_dom_1.Link, variant: 'body1', to: breadcrumb.path || '', key: `${breadcrumb.label}-${breadcrumb.path}` }, breadcrumb.label));
    return (react_1.default.createElement(StyledBreadcrumbs, { ref: breadcrumbsRef, "aria-label": 'breadcrumb' },
        first.map(renderBreadcrumb),
        between.length > 0 && (react_1.default.createElement("span", null,
            react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: event => setAnchorEl(event.currentTarget) },
                react_1.default.createElement(icons_1.MoreHoriz, { fontSize: 'small', htmlColor: '#a1c1e2' })),
            react_1.default.createElement(core_1.Menu, { open: !!anchorEl, anchorEl: anchorEl, onClose: () => setAnchorEl(null) }, between.map(breadcrumb => (react_1.default.createElement(core_1.MenuItem, { key: `${breadcrumb.label}-${breadcrumb.path}`, onClick: () => breadcrumb.path && history.push(breadcrumb.path) },
                react_1.default.createElement(core_1.ListItemIcon, null,
                    react_1.default.createElement(icons_1.Folder, { fontSize: 'small' })),
                react_1.default.createElement(core_1.Typography, { variant: 'inherit' }, breadcrumb.label))))))),
        last.map(renderBreadcrumb)));
};
exports.BreadcrumbSubheading = BreadcrumbSubheading;
exports.default = exports.BreadcrumbSubheading;
//# sourceMappingURL=BreadcrumbSubheading.js.map